import { MessageEnvelope } from '../../schema/message';

const normalizeMessage = (msg: MessageEnvelope): MessageEnvelope => {
  const displayTimetoken = msg.message?.eventTimestamp
    ? String(msg.message.eventTimestamp)
    : (msg.displayTimetoken ?? msg.timetoken);

  const channelId = msg.channel ?? msg.message.cId;

  return msg.displayTimetoken === displayTimetoken
    ? msg
    : { ...msg, displayTimetoken, channel: channelId };
};

export const mergeAndSortMessages = (
  existingMessages: MessageEnvelope[],
  incomingMessages: MessageEnvelope[]
): MessageEnvelope[] => {
  const messageMap = new Map<string | number, MessageEnvelope>();

  existingMessages.forEach((msg) =>
    messageMap.set(msg.timetoken, normalizeMessage(msg))
  );

  incomingMessages.forEach((msg) =>
    messageMap.set(msg.timetoken, normalizeMessage(msg))
  );

  return Array.from(messageMap.values()).sort(
    (a, b) => Number(a.displayTimetoken) - Number(b.displayTimetoken)
  );
};
